import app    from '../application';
import Amazon from './providers/amazon';
import Prebid from './providers/prebid';
import {
  showLog,
  showError
} from '../logger';
import {HEADER_BIDDING_READY} from '../constants';

const GATEWAYS = [
  Amazon,
  Prebid
];
const {RSVP} = window;
var _gatewaysPromises = [];
var _gatewaysAdded    = [];
var _gatewaysAdUnitCodes = [];

window.googletag     = window.googletag     || {};
window.googletag.cmd = window.googletag.cmd || [];
window.customcmd     = window.customcmd     || [];

export default Object.preventExtensions({
  /**
   * Get promises from gateways.
   * NOTE: Init method must be call before isActive method
   * @param {string}  device    - device type
   * @param {object}  config    - configGDPMedio object
   * @param {integer} dynamicId - dynamicId(infinite-scroll)
   */
  init(config) {
    _gatewaysPromises = [];
    // NOTE: load promises of active gateways
    _loadActivesGateways.call(_gatewaysPromises, config);

    // NOTE: when all promises are resolved, rejected or timeout reached, resolve the HB-Promise
    return RSVP.all(_gatewaysPromises)
      .then(function() {
        showLog('HBManager:init:All gateways have finished');
        app.promised(HEADER_BIDDING_READY, true);
      })
      .catch(function(reason) {
        showError('HBManager:init:Error in gateways', reason);
        app.promised(HEADER_BIDDING_READY, false);
      });
  },
  /**
   * Set targeting to DFP request
   */
  setTargetings() {
    showLog('HBManager:setTargetings:Setting targetings for each added gateways');
    _gatewaysAdded.forEach((gateway) => {
      let adUnits;
      _gatewaysAdUnitCodes.forEach(g => {
        if (g.gatewayName === gateway.NAME) {
          adUnits = g.adUnitCodes;
        }
      });
      gateway.setTargetings(adUnits);
    });
  },
  /**
   * Check if there are gateways actives
   */
  isActive() {
    return _gatewaysPromises.length;
  },
  getIsEmptyResponse() {
    let response = false;
    _gatewaysAdded.forEach((gateway) => {
      if (gateway.emptyResponse) {
        response = true;
      }
    });
    return response;
  },
  pushAdUnitForTargetings(adUnit) {
    _gatewaysAdUnitCodes.forEach((gateway) => {
      gateway.adUnitCodes.push(adUnit);
    });
  },
  getTargetingsCount() {
    let counter = 0;
    _gatewaysAdded.forEach(gateway => {
      if (gateway.NAME === 'PREBID') {
        counter = gateway.getTargetingsCount();
      }
    });
    return counter;
  }
});

/* Private */

/**
 * Load active gateways by config
 * @param {object} configGDPMedio
 */
function _loadActivesGateways(config) {
  _gatewaysAdded = [];
  GATEWAYS.forEach((gateway) => {
    const gatewayName = gateway.NAME;
    if (gateway.isActive(config)) {
      showLog('HBManager:loadActivesGateways:Add promise', gateway.NAME);
      _gatewaysAdded.push(gateway);
      _gatewaysAdUnitCodes.push({
        gatewayName,
        adUnitCodes: []
      });
      this.push(gateway.getLoadPromise(config));
    }
  });
}



// WEBPACK FOOTER //
// ./src/header-bidding/provider-manager.js